import { Dayjs } from 'dayjs';

export const timeOfTheDay = (dayJs: Dayjs) => {
  return dayJs.hour() * 3600 + dayJs.minute() * 60 + dayJs.second();
};
